
import { getShippingPDF, postJobEdit } from '@/api';
import POD from '@/components/jobDetailed/POD/POD.vue';
import { Job, User } from '@/models/main';
import { format } from 'date-fns';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { notificationErrorText } from '@/utils/PortalConstants';
import DateTimezoneToggle from '@/components/UI/dateTimezoneToggle/DateTimezoneToggle.vue';
import * as routeNames from '@/router/routeNames';

interface PODS {
  [key: number]: PODa;
}
interface PODa {
  jobId: number;
  jobUniqueId: string;
  jobDate: string;
  idx: number;
  podName: string;
}

@Component({
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
  components: {
    DateTimezoneToggle,
    POD,
  },
})
export default class KJobTimeline extends Vue {
  @Prop({ required: true }) private job!: Job;
  @Prop({ type: Boolean, default: false }) private showEdit!: boolean;

  public routeNames = routeNames;
  private readonly URL: string | undefined = process.env.VUE_APP_API;
  private user!: User;
  private loading = false;
  private loadingPDF = false;
  private PODs: PODS = {};
  private format = format;

  private toggleJobHiding(job): void {
    this.loading = true;
    const params = {
      job_id: job.id,
      job_date: job.job_date,
      note: !job.is_done ? 'The job was hidden' : 'The job was returned',
      is_done: !job.is_done,
    };
    postJobEdit(params, this.user.username).finally(() => {
      this.loading = false;
    });
  }

  // Helper function to determine a main Stop of a Job
  private customerStopNumber() {
    const serviceCode = this.job.cost_service;
    const firstStopCustomerEndings = ['PO', 'CO', 'CT'];
    const lastTwoLetters = serviceCode.slice(-2);
    return firstStopCustomerEndings.includes(lastTwoLetters) ? 1 : 2;
  }

  // Helper function to render SCs of a Job
  // TODO: unknown logic to filter Z and Refresh???
  private get services() {
    return this.job.services
      .filter((sv: string) => {
        return !(sv[0] === 'Z' || sv === 'REFRESH');
      })
      .join(', ');
  }

  // Helper function to determine a main Stop of a Job
  // TODO: Refactor to use this or customerStopNumber
  private isStop1Main() {
    for (const serviceCode of this.job.services) {
      if (
        serviceCode.search(/\b\w\wPO\b/) !== -1 ||
        serviceCode.search(/\b\w\wIT\b/) !== -1 ||
        serviceCode.search(/\b\w\wST\b/) !== -1
      ) {
        return true;
      }
    }
    return false;
  }

  @Watch('job.unique_id', { immediate: true })
  private updatePOD() {
    this.PODs = {};
    // Only 2 PODs possible
    for (let i = 1; i <= 2; i++) {
      if (this.job['pod_time' + i]) {
        this.PODs[i - 1] = {
          jobId: Number(this.job.id),
          jobUniqueId: this.job.unique_id,
          jobDate: format(new Date(this.job.job_date), 'yyyy-MM-dd'),
          idx: i - 1,
          podName: this.job['pod_name' + i],
        };
      }
    }
  }

  private downloadShippingPdf(job_id, job_date): void {
    this.loadingPDF = true;
    getShippingPDF(job_id, job_date)
      .then(res => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(res);
        link.download = `${job_id}-${job_date}.pdf`;
        link.click();
        URL.revokeObjectURL(link.href);
        link.remove();
      })
      .catch(() => {
        this.$notify({
          group: 'network',
          title: 'Error downloading the pdf',
          text: notificationErrorText,
          type: 'warn',
        });
      })
      .finally(() => {
        this.loadingPDF = false;
      });
  }
}
